import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { config } from '@config/pendo.config.json';
import { tagItemStyles } from './styles';

interface TagItemProps {
  id: number;
  name: string;
  onDelete: (id: number) => void;
}

const TagItem: React.FC<TagItemProps> = ({ id, name, onDelete }) => (
  <div css={tagItemStyles}>
    <span className='name ellipsis'>{name}</span>
    <ClickableContainer
      onClick={() => onDelete(id)}
      className='close-btn'
      data-qa={config.pendo.aiLearning.removeAdminAssistant}
    >
      <NvIcon icon='close' size='smallest' />
    </ClickableContainer>
  </div>
);

export default TagItem;
